import React from 'react';
import { DatedEvidence, Evidence } from '@eas/common-web';
import { EvidenceApiUrl, ExportTag, Permission } from '@enums';
import { useEvidencePermission } from '@utils/permission-hook';
import { useIntl } from 'react-intl';
import { ImportRequest } from '@models';
import { useColumns } from './import-request-columns';
import { Fields, hasBlockingError } from './import-request-fields';
import { ImportRequestToolbarExport } from './import-request-toolbar-export';

export function ImportRequests() {
  const intl = useIntl();
  const columns = useColumns();

  const permissions = useEvidencePermission({
    options: {
      NEW: [],
      EDIT: [],
      REMOVE: [],
      REFRESH: [Permission.Default.ADMINISTRATOR],
      SHARE: [],
      CHECK: [],
      SAVE: [],
      CLOSE: [],
    },
  });

  const evidence = DatedEvidence.useDatedEvidence<ImportRequest>({
    version: 3,
    identifier: 'IMPORT_REQUEST',
    apiProps: {
      url: EvidenceApiUrl.IMPORT_REQUEST,
    },
    tableProps: {
      columns,
      tableName: intl.formatMessage({
        id: 'TAPIS__IMPORT_REQUEST__TABLE__TITLE',
        defaultMessage: 'Importy datové základny',
      }),
      createRowStyle: ({ nonStandardStates, processState }) => {
        const hasError = hasBlockingError(nonStandardStates, processState);

        return { color: hasError ? 'red' : 'initial' };
      },

      reportTag: ExportTag.IMPORT_REQUEST_GRID,
    },
    detailProps: {
      FieldsComponent: Fields,
      toolbarProps: {
        title: intl.formatMessage({
          id: 'TAPIS__IMPORT_REQUEST__DETAIL__TITLE',
          defaultMessage: 'Přehled importů datové základny',
        }),
        showBtn: permissions,
        After: ImportRequestToolbarExport,
      },
    },
  });

  return <Evidence {...evidence} />;
}
